import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "dashboard-referral-card",
  components: {},
  props: [],
  data() {
    return {
      dashboardReferralLoader: true,
      baseUrl: process.env.VUE_APP_BASE_URL
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO
    })
  },
  mounted() {
    setTimeout(() => {
      this.dashboardReferralLoader = false;
    });
  },
  methods: {
    onCopy() {
      this.$toast.success(
        this.$t("dashboardPage.referralCard.referralCodeCopied")
      );
    },
    onCopyLink() {
      this.$toast.success(
        this.$t("dashboardPage.referralCard.referralLinkCopied")
      );
    }
  }
};
